import React, { FC } from "react"
import { Modal } from "react-bootstrap"
import { AiOutlineCloseCircle } from "react-icons/ai"
import ButtonComponent from "../Button/ButtonComponent"
import TextComponent from "../TextComponent/TextComponent"
import "./ModalTextInfo.scss"

interface IModalTextInfoProps {
  title: string
  description: string
  buttonText: string
  open: boolean
  onClose?: () => void
}

const ModalTextInfo: FC<IModalTextInfoProps> = ({
  open,
  onClose,
  title,
  description,
  buttonText,
}) => {
  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName='dialog-text-info--component'
    >
      <Modal.Body>
        <div
          className="modal-text-info--layout"
        >
          <div className="modal-text-info--header">
            <p>{title}</p>
            <AiOutlineCloseCircle
              onClick={onClose}
            />
          </div>
          <TextComponent padding="10px" type="text" style={{ color: 'var(--text3)' }}>{description}</TextComponent>
          <ButtonComponent onClick={onClose} variant="secondary">
            {buttonText}
          </ButtonComponent>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ModalTextInfo
